export enum BannerAppearance {
  Success = 'success',
  Warning = 'warning',
  Danger = 'danger',
  Info = 'info',
}
